import React, {forwardRef} from "react";

export const Fingerprint = forwardRef<HTMLIFrameElement, unknown>(function Fingerprint(_, ref) {
    return (
        <iframe
            ref={ref}
            src="about:blank"
            style={{
                width: "1px",
                height: "1px",
                border: "0px",
                position: "absolute",
                left: "-10000px",
                top: "-10000px",
            }}
            width="1"
            height="1"
            id="signatureContainer"
            title="signature"
        ></iframe>
    );
});
